/*
 * @Author: edvardchen
 * @Date: 2017-12-06 17:35:42
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-12-21 14:50:53
 */

// @flow
import _ from 'lodash';
import querystring from 'query-string';
import cookies from 'js-cookie';
import { isAndroid, isIOS } from '@tencent/qb-article-util/lib/UA';
import { type Dispatch, type GetState } from '../types';
import { makeAutohomeReport, feedsReport2BzServer } from '../../ducks/article';
import { track, onVisibilityChange } from '../../utility';
import { getQIMEI, getIDFA } from '../../utility/C4PV';
import { beaconReport } from '../../utility/DOM';
import { customerLogReport } from '../../fetchers/circle_client';
declare var __CLIENT__: boolean;

const INTERVAL = 200; // 0.2s 使用定时器，防止由于系统时间修改导致时长异常
let duration = 0;
let timer: *;

const startRecording = () => {
  duration = 0; // reset
  return setInterval(() => {
    duration += INTERVAL;
  }, INTERVAL);
};
const videosPause = () => {
  const videos = Array.prototype.slice.call(document.getElementsByTagName('video')) || [];
  if (videos.length) {
    videos.forEach((el) => {
      if (el && !el.paused) {
        el.pause && el.pause();
      }
    });
  }
};
let inited = false;
export default () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article: { docId },
    location,
    user: { qbid },
    apn = '',
  } = getState();
  const { query: { ch, extenddata, pid = '' } = {} } = location;
  if (!docId) {
    console.warn('this is not an article');
    return;
  }
  if (inited) {
    console.warn('try to call makeRecordReadingTimeForQEH again');
    return;
  }
  let queryId = '';
  let extData = {};
  if (extenddata) {
    extData = querystring.parse(extenddata);
    queryId = extData.queryId || '';
  }
  inited = true;
  timer = startRecording();
  const ua = window.navigator.userAgent || '';
  let qimei = '';
  let platform = '';
  if (isAndroid(ua)) {
    platform = 'android';
    qimei = (await getQIMEI()) || '';
  } else if (isIOS(ua)) {
    platform = 'ios';
    qimei = (await getIDFA()) || '';
  }
  const version = _.get(window, 'browser.env.version') || '';
  const guid = cookies.get('qb_guid') || '';
  onVisibilityChange((event, hidden) => {
    // console.debug('reportReading', hidden, duration, Date.now());
    timer && clearInterval(timer); // 向后兼容，不管怎样，先停止定时器
    if (hidden) {
      videosPause();
      window.WINDOW_WELFALE_READ_TIMING_INTERVAL && clearInterval(window.WINDOW_WELFALE_READ_TIMING_INTERVAL);
      window.WINDOW_WELFALE_READ_TIMING_INTERVAL = null;
      if (duration === 0) {
        console.warn('reportReading something wrong: duration is zero');
        return;
      }
      const second = duration / 1000;
      // 汽车之家上报
      dispatch(makeAutohomeReport(second));
      // 特征累计上报到大数据 使用的是feeds的上报部分 jerryfwang
      dispatch(feedsReport2BzServer(second, extData));
      track({
        location: 'article',
        object: 'article',
        action: 'read',
        id: docId,
        ext: `${second} | ${queryId} | ${qimei}`,
        ch,
      });
      if (window._READINGDATA) {
        const { readH, articleH, exposureImage, page } = window._READINGDATA || {};
        if (readH && articleH) {
          const rate = Math.floor((readH / articleH) * 100);
          beaconReport({
            key: 'News_Exit_Reading_Info',
            params: {
              readH,
              articleH,
              exposureImage,
              page,
              rate,
            },
          });
          customerLogReport({
            logType: 1,
            logContent: `readInfo|${guid}|${qimei}|${qbid}|${platform}|${version}|${apn}|${docId}|${pid}|${readH}|${articleH}|${rate}`,
          });
        }
        window._READINGDATA = null;
      }
    } else {
      timer = startRecording();
    }
  });
};
